import './modules/forms';
import './modules/accordion';
import './modules/sliders';
import './modules/instagram';
//import './modules/instagrammer';
import './modules/gallery';
import './modules/lightbox';
import './modules/socialShare';
import './modules/scrollTop';
import './modules/script';
import './modules/video-player';